const DOMElements = {
    searchButton: () => document.querySelector(`button#sub_search`),
    addressInput: () => document.querySelector(`input#Address`),
}

let urlForm = null;

function initialize() {
    urlForm = null
        || window.searchSubsidiaryBox.config.urlForm;

    if (urlForm == null) {
        throw Error("Unable to initialize script. UrlForm is null.");
    }
}

function setUrlParameter(queryPart) {
    if (urlForm.indexOf("?") >= 0)
        return urlForm + "&" + queryPart;
    else
        return urlForm + "?" + queryPart;
}

function main() {
    initialize();

    //Evento per il click del bottone
    DOMElements.searchButton().addEventListener(`click`, e => {
        e.preventDefault();
        var queryPart = "";
        var addressSearch = DOMElements.addressInput().value;
        if (addressSearch !== "undefined" && addressSearch.length > 0) {
            queryPart = "Address=" + addressSearch;
        }
        window.location.href = setUrlParameter(queryPart);
    });

    DOMElements.addressInput().addEventListener(`focus`, e => {
        DOMElements.addressInput().setAttribute("placeholder", "Inserisci il CAP o la città");
    });
    DOMElements.addressInput().addEventListener(`blur`, e => {
        DOMElements.addressInput().setAttribute("placeholder", "");
    });
    //Evento per la pressione con invio.
    DOMElements.addressInput().addEventListener(`keydown`, e => {
        e.stopPropagation();
        if (e.key === "Enter") {
            e.preventDefault();
            e.returnValue = false;
            e.cancel = true;
            DOMElements.searchButton().dispatchEvent(new Event("click"));
        }
    });
}

main();